import { Panel, PanelProps } from "@mcleod/components";
import { FinalizedExample } from "./FinalizedExample";
import { LiveExampleComponents } from "./LiveExampleComponents";

/**
 * The panel that renders the group of examples for either a single component property or a single entry in the 
 * additional examples section.
 */
export class ExamplesPanel extends Panel {
    private examples: FinalizedExample[];

    constructor(examples: FinalizedExample[], props?: Partial<PanelProps>) {
        super({
            visible: false,
            borderColor: "strokeSecondary",
            color: "default",
            borderRadius: 4,
            marginLeft: 48,
            marginRight: 112,
            padding: 8,
            marginBottom: 12,
            backgroundColor: "background2",
            fillRow: true,
            ...props
        });
        this.examples = examples;
    }

    async showExamples() {
        if (this.borderWidth == 1)
            return;
        this.buildExamples();
        await this.hideExamples(false);
        this.visible = true; // Only has an effect on the first render, stays visible afterward
        this.setProps({
            borderWidth: 1,
            borderShadow: true,
        });
        await this.expand({ speed: 400 });
    }

    async hideExamples(useTransition: boolean = true) {
        useTransition ? await this.collapse() : this.collapseNow();
        this.setProps({
            borderWidth: 0,
            borderShadow: false
        });
    }

    private buildExamples() {
        if (!this.isEmpty())
            return;
        this.examples.forEach((exampleInput, index) => {
            const exampleComponents =
                new LiveExampleComponents(exampleInput)
                .build()
                .get();
            this.add(...exampleComponents);
            if (index < this.examples.length - 1)
                this.add(this.createSeparatorPanel())
        });
    }

    private createSeparatorPanel(): Panel {
        return new Panel({
            borderBottomWidth: 1,
            borderBottomColor: "strokeSecondary",
            marginRight: 48,
            marginLeft: 48,
            fillRow: true,
            marginBottom: 16
        });
    }    
}
